import { createFileRoute } from '@tanstack/react-router'
import { ArticleDetail } from '../../../pages/ArticleDetail'

export const Route = createFileRoute('/helpdesk/knowledge-base/$id')({
  component: ArticleDetail,
})